import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Add from "./pages/Add";
import ProtectedRoute from "./components/ProtectedRoute";
import AddPlatform from "./pages/AddPlatform";
import AddNumber from "./pages/AddNumber";
import UpdateData from "./pages/UpdateData";
import SEO from "./pages/SEO";
import Whats from "./pages/Whats";
import SEOUpdate from "./pages/SEOUpdate";
import Report from "./pages/Report";
import AddCompleteReport from './pages/AddCompleteReport';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addclient"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <Add />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addplatform"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <AddPlatform />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addnumber"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <AddNumber />
            </ProtectedRoute>
          }
        />
        <Route
          path="/update"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <UpdateData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/seo"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <SEO />
            </ProtectedRoute>
          }
        />
        <Route
          path="/whats"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <Whats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/seoupdate"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <SEOUpdate />
            </ProtectedRoute>
          }
        />
          <Route
          path="/report"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <Report />
            </ProtectedRoute>
          }
        />
           <Route
          path="/complete-report"
          element={
            <ProtectedRoute allowedRoles={["admin", "gust"]}>
              <AddCompleteReport />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
